export default {
  brandColor1: '#85B09A',
  complimentaryColor1: '#fff',
  brandColor2: '#313131',
  complimentaryColor2: '#fff',
};
